// eslint-disable-next-line import/no-cycle
import CollectionsModule from './CollectionsModule';

export * from './CollectionsModule';
export default CollectionsModule;
